import { render, staticRenderFns } from "./BrowseDaichoEdited.vue?vue&type=template&id=3d863bbb&scoped=true&"
import script from "./BrowseDaichoEdited.vue?vue&type=script&lang=js&"
export * from "./BrowseDaichoEdited.vue?vue&type=script&lang=js&"
import style0 from "./BrowseDaichoEdited.vue?vue&type=style&index=0&id=3d863bbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d863bbb",
  null
  
)

export default component.exports